<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
     <base-material-dialog
        title='电话跟进'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='430'
      >
      <template v-slot:content>
        <v-card elevation="0">
           <v-card-text>
             <div v-for="(i, idx) in item.data.allContactsPersons" :key="idx" >
              <v-row class="my-2">
                  <v-col md="3" class="text-left">
                    <v-chip label small dark :color="i.type ===1 ? 'blue' : 'green'">{{i.type ===1 ? '客户方' : '渠道方'}}</v-chip>
                  </v-col>
                  <v-col md="3" class="text-center">
                    {{i.name}}
                  </v-col>
                  <v-col md="4" class="text-center">
                    {{i.phoneNumber}}
                  </v-col>
                  <v-col md="2" class="text-right">
                    <v-btn x-small depressed fab :loading="loading" class="mt-n2" @click="call(i)"><v-icon>mdi-phone</v-icon></v-btn>
                  </v-col>
              </v-row>
              <v-divider></v-divider>
             </div>
            </v-card-text>
          <v-card-actions>
            <!-- {{item.data.allContactsPersons}} -->
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <v-overlay :value="loading" absolute>
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </base-material-dialog>
  </v-container>
</template>

<script>

  import { call } from '@/api/call/info.js'

  export default {
    name: 'CustomerCall',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false
      }
    },
    methods: {
      call (item) {
        this.loading = true
        call(item.phoneNumber).then(res => {
          if (res.status === 200) {
            this.$dialog.notify.success('拨号成功,请注意接听来电！', { position: 'top-right', timeout: 4000 })
            this.$emit('on-call-success', {
              customerId: this.item.data.id,
              followTypeId: this.$constants.CustomerFollowType.CALL_ID,
              contactsId: item.id,
              followTimeStr: this.$moment().format('YYYY-MM-DD'),
              allContactsPersons: [{ id: item.id, name: item.name }]
            })
            this.item.show = false
          }
          this.loading = false
        })
      },
      dialogChange (val) {
        this.item.show = val
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
